import React from 'react';
import { View, Text, StyleSheet, Pressable } from 'react-native';
import { useTranslation } from 'react-i18next';
import Feather from '@expo/vector-icons/Feather';
import { Paprika, PaprikaSpacing } from '../../../styles/theme';
import { PantryItemView } from '../../../redux/pantrySelectors';
import { CookList } from '../CookList';

interface Props {
  items: PantryItemView[];
  onBack: () => void;
  onItemPress: (itemId: string) => void;
  onEat: (item: PantryItemView) => void;
}

export function CookView({ items, onBack, onItemPress, onEat }: Props) {
  const { t } = useTranslation();

  return (
    <View style={styles.root}>
      {/* Header */}
      <View style={styles.header}>
        <Pressable onPress={onBack} style={styles.backButton}>
          <Feather name="chevron-left" size={24} color={Paprika.textPrimary} />
        </Pressable>
        <View style={styles.titleBox}>
          <Text style={styles.title}>{t('pantry.cook.screenTitle')}</Text>
          <Text style={styles.subtitle}>{t('pantry.cook.screenSub')}</Text>
        </View>
      </View>

      {/* List */}
      <CookList
        items={items}
        onCook={onItemPress}
        onEat={onEat}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: Paprika.background,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: PaprikaSpacing.md,
    paddingVertical: PaprikaSpacing.md,
    paddingHorizontal: PaprikaSpacing.md,
    borderBottomWidth: 1,
    borderBottomColor: Paprika.hairline,
  },
  backButton: {
    padding: 8,
    marginLeft: -8,
  },
  titleBox: {
    flex: 1,
  },
  title: {
    fontFamily: 'Newsreader-Italic',
    fontSize: 20,
    color: Paprika.textPrimary,
  },
  subtitle: {
    fontFamily: 'Inter-Regular',
    fontSize: 13,
    color: Paprika.textMuted,
    marginTop: 2,
  },
});
